export interface Breadcrumb {
  name: string;
  link?: string;
}
